export default __webpack_public_path__ + "static/patrik-full-f32f920eb7937986fd588fffb35b7c12.png";